import { Star } from 'lucide-react';

interface TestimonialCardProps {
  quote: string;
  name: string;
  source: 'App Store' | 'TikTok';
  rating?: number;
}

/**
 * RFC-150: platform chip ("App Store" / "TikTok") rendered above the quote
 * for masonry-friendly rhythm.
 */
export function TestimonialCard({ quote, name, source, rating }: TestimonialCardProps) {
  return (
    <blockquote 
      className="bg-card rounded-2xl p-6 shadow-card border border-border flex flex-col break-inside-avoid mb-6"
      cite={source === 'App Store' ? 'https://apps.apple.com/app/leka-learning/id6758303395' : undefined}
    >
      <div className="flex items-center justify-between mb-3">
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
          source === 'App Store' 
            ? 'bg-secondary text-secondary-foreground' 
            : 'bg-primary/10 text-primary'
        }`}>
          {source}
        </span>
        {rating && (
          <div className="flex gap-0.5" aria-label={`${rating} out of 5 stars`}>
            {Array.from({ length: rating }).map((_, i) => (
              <Star key={i} className="w-4 h-4 fill-primary text-primary" />
            ))}
          </div>
        )}
      </div>
      <p className="text-foreground text-sm leading-relaxed mb-4">
        "{quote}"
      </p>
      <footer>
        <cite className="text-sm font-medium text-foreground not-italic">
          {name}
        </cite>
      </footer>
    </blockquote>
  );
}
